import React, { Component } from "react"
import PropTypes from "prop-types"

export default class Footer extends Component {
  handleClick = event => {
    event.preventDefault()
    this.props.onSaveClicked()
  }

  render() {
    return (
      <div className="config-footer">
        {this.props.includeSubmit && (
          <div className="button">
            <input
              type="button"
              className="btn"
              onClick={this.handleClick}
              value="Done"
              disabled={!this.props.enabled}
            />
          </div>
        )}
      </div>
    )
  }
}

Footer.propTypes = {
  applet: PropTypes.object,
  onSaveClicked: PropTypes.func,
  enabled: PropTypes.bool,
  includeSubmit: PropTypes.bool,
}
